// Local contact points match the runtime tool geometry. Keep animation pivots
// in the palm instead of rotating a tool around the centre of its body.
export const AVATAR_TOOL_CONTACTS = Object.freeze({
  rod: Object.freeze([0, 0, 0]), shovel: Object.freeze([0, 0, 0]),
  axe: Object.freeze([0, 0, 0]), net: Object.freeze([0, 0, 0]),
  wateringCan: Object.freeze([-.02, .265, 0]),
});

export function attachAvatarTools(toolRoot, tools) {
  for (const [name, contact] of Object.entries(AVATAR_TOOL_CONTACTS)) {
    const tool = tools[name];
    if (!tool) continue;
    tool.position.set(...contact).applyQuaternion(tool.quaternion).multiplyScalar(-1);
    tool.userData.contactPoint = [...contact];
    toolRoot.add(tool);
  }
}
